module.exports = __webpack_public_path__ + "static/media/MultiChoice.b7438a49.png";